import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

interface QrPanelProps {
  /** The URL to encode — typically the current page URL. */
  url: string;
}

/**
 * Renders the current page URL as a QR image. CSS hides this on narrow screens
 * and shows it as a side column on wide screens (min-width: 720px).
 */
export default function QrPanel({ url }: QrPanelProps) {
  const [dataUrl, setDataUrl] = useState<string>('');

  useEffect(() => {
    let cancelled = false;
    QRCode.toDataURL(url, { margin: 1, width: 220 })
      .then((d) => {
        if (!cancelled) setDataUrl(d);
      })
      .catch(() => {
        if (!cancelled) setDataUrl('');
      });
    return () => {
      cancelled = true;
    };
  }, [url]);

  if (!dataUrl) return null;

  return (
    <aside className="qr-panel">
      <img className="qr-panel__img" src={dataUrl} alt="当前确认单二维码" width={220} height={220} />
      <p className="qr-panel__caption">当前确认单也支持手机扫码操作</p>
    </aside>
  );
}
